module.exports = __webpack_public_path__ + "static/media/3_Pre-Check-Doorbell-Size-Left.2c650100.svg";